import { InjectionToken } from '@angular/core';
import { RootStore, Store } from '@sama/app-state';
import { isDefined } from '@sama/js-core';
import { mixInInjectableSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { ShapeLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/shape-layer-state';
import { logStateToDevtools } from '../../../../../cross-team-shared/test-helpers/state-logging';
import { isShapeLayer } from '../layers/layer-utils';
import { AnnotationState } from './annotation-state';

export const annotationStoreToken = new InjectionToken<AbstractAnnotationStore>(
  'annotation store',
);

export abstract class AbstractAnnotationStore<
  T extends AnnotationState = AnnotationState,
> extends mixInInjectableSuperclass(RootStore)<T> {
  ready$ = this('status').$.pipe(filter((status) => status === 'ready'));

  constructor(initialState: T) {
    super(initialState);
    this.manage(logStateToDevtools(this, 'AnnotationStore'));
  }

  getActiveLayerStore(): Store<T['layers'][number]> {
    const state = this.state();
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    return this('layers')(state ? state.activeLayerIndex : 0);
  }

  getActiveShapeLayerStore(): Store<ShapeLayerState> | undefined {
    const store = this.getActiveLayerStore();
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    if (store.state() && isShapeLayer(store.state())) {
      // This is necessary to make the typing work
      return store as Store<any>;
    } else {
      return undefined;
    }
  }

  getActiveLayer$(): Observable<T['layers'][number]> {
    return this('activeLayerIndex').$.pipe(
      filter(isDefined),
      switchMap((activeLayerIndex) =>
        this('layers')(activeLayerIndex).$.pipe(filter(isDefined)),
      ),
    );
  }

  setError(errorMessage: string) {
    this.assign({ status: 'error', errorMessage } as Partial<T>);
  }
}
